import { useRef, useContext } from "react";
import { AppContext } from "../data/store";
import { ethers } from "ethers";
import { CONTRACT_ABI, contractAddress } from "../data/contract";
const { ethereum } = window;
const Form = () => {
  const addressRef = useRef();
  const billRef = useRef();
  const textRef = useRef();

  const { user, message, setMessage } = useContext(AppContext);

  const sendToken = async () => {
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    const contract = new ethers.Contract(contractAddress, CONTRACT_ABI, signer);

    const parsedAmount = ethers.utils.parseEther(billRef.current.value);

    try {
      await ethereum.request({
        method: "eth_sendTransaction",
        params: [
          {
            from: user.walletAddress,
            to: addressRef.current.value,
            gas: "0x5208",
            value: parsedAmount._hex,
          },
        ],
      });

      const tx = await contract.addToBlockchain(
        addressRef.current.value,
        parsedAmount,
        textRef.current.value
      );
      await tx.wait();

      setMessage("");
    } catch (error) {
      setMessage(error.message);
    }
  };

  return (
    <div className="text-white px-12 ml-0 lg:ml-36">
      {message && (
        <p className="bg-[#67ca99] rounded-lg border-r-4 border-r-red-600 px-6 py-2 mb-12">
          {message}
        </p>
      )}
      <div className="input__group">
        <label className="text-sm text-[#e5e4e2]">My Wallet</label>
        <input
          type="text"
          value={user?.walletAddress}
          className="input__text"
          readOnly
        />
      </div>
      <div className="input__group">
        <label className="text-sm text-[#e5e4e2]">Bearer Desk</label>
        <input type="text" ref={addressRef} className="input__text" required />
      </div>
      <div className="input__group">
        <label className="text-sm text-[#e5e4e2]">Amount</label>
        <input type="text" ref={billRef} className="input__text" required />
      </div>

      <div className="input__group">
        <label className="text-sm text-[#e5e4e2]">Message</label>
        <textarea rows="3" ref={textRef} className="input__text" />
      </div>
      <button onClick={sendToken} className="block__button">
        Transfer Now
      </button>
    </div>
  );
};

export default Form;
